import { Api } from './api';
import { WheelOfFortuneApi } from './games/wheel-of-fortune.api';

export class GamesApi {
    public static readonly PATH = '/games';

    public wheelOfFortune: WheelOfFortuneApi;

    constructor(api: Api) {
        this.wheelOfFortune = new WheelOfFortuneApi(api);
    }
}